import { useLocalization } from '@lib/localization';
import { Stack, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { PlayIcon } from 'react-line-awesome';

export type PoiTypeView = 'designer' | 'table' | 'json';

interface Props {
  view: PoiTypeView;
  trying: boolean;
  onView: (view: PoiTypeView) => void;
  onTry: (trying: boolean) => void;
}

const buttonStyles = { textTransform: 'none', fontWeight: 600, px: 1.5, py: 0.25 };

/**
 * How a POI type's page shows it: the designer, the field table or the JSON, and Try it beside
 * them on its own, since it is not another way to edit but the form as an inspector meets it.
 */
const ViewSwitch: React.FC<Props> = ({ view, trying, onView, onTry }) => {
  const { t } = useLocalization();

  return (
    <Stack direction="row" justifyContent="flex-end" spacing={1} sx={{ mb: 1.5 }}>
      <ToggleButtonGroup
        exclusive
        size="small"
        value={trying ? null : view}
        onChange={(_event, next: PoiTypeView | null) => next && onView(next)}
        sx={{ '& .MuiToggleButton-root': buttonStyles }}
      >
        <ToggleButton value="designer">{t('Customization_Designer_ViewDesigner')}</ToggleButton>
        <ToggleButton value="table">{t('Customization_Designer_ViewTable')}</ToggleButton>
        <ToggleButton value="json">{t('Customization_Designer_ViewJson')}</ToggleButton>
      </ToggleButtonGroup>
      <ToggleButton
        size="small" value="try" color="primary" selected={trying} sx={{ ...buttonStyles, gap: 0.75 }}
        onChange={() => onTry(!trying)}
      >
        <PlayIcon />
        {t('Customization_Designer_TryIt')}
      </ToggleButton>
    </Stack>
  );
};

export default ViewSwitch;
